import { NgModule } from '@angular/core';
import { MomentDatePipe } from './moment-timezone.pipe';


@NgModule({
  declarations: [
    MomentDatePipe,
  ],
  exports: [MomentDatePipe]
})
export class MomentTimezonePipeModule { }
